import React, { useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";;
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableHead from "../../../_uiMocks/_uiComponents/UiTableHead";
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import UiConfirmationDialog from "../../../_uiComponents/common/UiConfirmationDialog";
import UsersTableManage from "./UsersTableManage";



function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export default function Users(props) {
     const [page, setPage] = React.useState(0);
     const [rowsPerPage, setRowsPerPage] = React.useState(3);
     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [open, setOpen] = React.useState(false);
     const [active, setActive] = React.useState();
     const [editModal, setEditModal] = React.useState(false);
     const [character, setCharacter] = React.useState("");
     const [dialogOpen, setDialogOpen] = React.useState(false);

     const handleEditShow = () => setEditModal(true);
     const handleCloseEdit = () => setEditModal(false);

     const manageOpen = (clickedIndex) => {
          if (active === clickedIndex) {
               setActive(null);
               setOpen(true);
          } else {
               setActive(clickedIndex);
               setOpen(true);
          }
     };

     const dialogHandleOpen = () => {
          setDialogOpen(true);
     };

     const dialogHandleClose = () => {
          setDialogOpen(false);
     };

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage);
     };
     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(+event.target.value);
          setPage(0);
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          console.log(property)
          const isAsc = orderBy === property && order === "asc";
          console.log(isAsc)
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };
     const options1 = [
          { value: "value-1", label: "Sales" },
          { value: "value-2", label: "Sales" },
          { value: "value-3", label: "Sales" },
     ];

     const handleChangetype = (event) => {
          setCharacter(event.target.value);
     };

     const headings = [
          { id: "dealer", name: "Dealer" },
          { id: "fname", name: "First Name" },
          { id: "lname", name: "Last Name" },
          { id: "email", name: "Email" },
          { id: "type", name: "User Type" },
          { id: '', name: '' },
          { id: '', name: '' }
     ];

     const rows = [
          {
               id: 1,
               dealer:"Renault",
               fname: "Saman",
               lname: "nihal",
               email: "saman@gmail.com",
               typeSt: "1",

               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                    },
               ],
          },
          {
               id: 2,
               dealer:"Toyota",
               fname: "Chamani",
               lname: "nimal",
               email: "chamani@gmail.com",
               typeSt: "2",
               
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                         customerId: "11091700",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                         customerId: "Anonymous",
                    },
               ],
          },
          {
               id: 3,
               dealer:"Renault",
               fname: "Chandani",
               lname: "nimali",
               email: "chandani@gmail.com",
               typeSt: "3",
               
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                         customerId: "11091700",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                         customerId: "Anonymous",
                    },
               ],
          },
     ];

     //Empty rows issue set
     const emptyRows =
          page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
     console.log(emptyRows);
     const [newRows, setNewRows] = React.useState(rows);
     const [subTableData, setSubTableData] = useState(rows);

     //Add row modal
     const [openAddFieldModal, setOpenAddFieldModal] = React.useState(false);
     const subTableModalOpen = () => setOpenAddFieldModal(true);
     const handleClose = () => setOpenAddFieldModal(false);
    
     //Data sorting
     const visibleRows = React.useMemo(
          () =>
               stableSort(rows, getComparator(order, orderBy)).slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
               ),
          [order, orderBy, page, rowsPerPage, rows],
     );
   
     //Drag and drop reorder
     const reorder = (list, startIndex, endIndex) => {
          const result = Array.from(list);
          const [removed] = result.splice(startIndex, 1);
          result.splice(endIndex, 0, removed);
          return result;
     };

     //Switch function
     const handleChange = (event, index) => {
          let newArr = [...newRows];
          newArr[index].enable = event.target.checked;
          setNewRows(newArr);
     };

     //Ondrag function
     const onDragEnd = (result) => {
          const { type, source, destination } = result;
          if (!destination) return;
          const sourceCategoryId = source.droppableId;
          const destinationCategoryId = destination.droppableId;

          if (type === "droppable-item") {
               if (sourceCategoryId === destinationCategoryId) {
                    const updatedOrder = reorder(
                         subTableData.find(
                              (category) => category.id === sourceCategoryId,
                         ).items,
                         source.index,
                         destination.index,
                    );
                    const updatedCategories = subTableData.map((category) =>
                         category.id !== sourceCategoryId
                              ? category
                              : { ...category, items: updatedOrder },
                    );
                    setSubTableData(updatedCategories);
               }
          }
     };

     return (
          <>         
               <div className="sba-table-main-wr">
                    <UiTableWrapper>
                         <UiTableHead
                              headings={headings}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                         />

                         <UiTableBody>
                              {visibleRows.map((row, index) => (
                                   <>
                                        <TableRow
                                             key={row.id}
                                             sx={{
                                                  "&:last-child td, &:last-child th":
                                                       { border: "none" },
                                             }}
                                        >
                                             <TableCell align="left">
                                                  <strong>{row.dealer}</strong>
                                             </TableCell>
                                             <TableCell align="center">
                                                  {row.fname}
                                             </TableCell>
                                             <TableCell align="center">
                                                  {row.lname}
                                             </TableCell>
                                             <TableCell align="center">
                                                 {row.email}                                                
                                             </TableCell>
                                             <TableCell align="center">
                                                  <strong>{row.typeSt}</strong>
                                             </TableCell>
                                                                                         
                                             <TableCell align="right">
                                                  <Button
                                                       size="small"
                                                       variant="outlined"
                                                       endIcon={
                                                            active == index &&
                                                                 open ? (
                                                                 <KeyboardArrowUpIcon />
                                                            ) : (
                                                                 <KeyboardArrowDownIcon />
                                                            )
                                                       }
                                                       onClick={() => {
                                                            manageOpen(index);
                                                       }}
                                                  >
                                                       Manage
                                                  </Button>
                                             </TableCell>
                                             <TableCell
                                                  align="right"
                                                  sx={{ width: "110px" }}
                                             >
                                                  <div className="sbt-data-grid__action-bar">
                                                       <InfoIcon className="sba-grid-info-icon" />
                                                       <Tooltip
                                                            title="Edit"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 aria-label="Edit"
                                                                 onClick={
                                                                      handleEditShow
                                                                 }
                                                                 sx={{
                                                                      ml: 1.5,
                                                                 }}
                                                            >
                                                                 <EditIcon />
                                                            </IconButton>
                                                       </Tooltip>
                                                       <Tooltip
                                                            title="Delete"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 aria-label="delete"
                                                                 sx={{
                                                                      ml: 0.5,
                                                                 }}
                                                                 onClick={
                                                                      dialogHandleOpen
                                                                 }
                                                            >
                                                                 <DeleteIcon color="error" />
                                                            </IconButton>
                                                            <UiConfirmationDialog
                                                                 title="Delete Confirmation"
                                                                 open={
                                                                      dialogOpen
                                                                 }
                                                                 onClose={
                                                                      dialogHandleClose
                                                                 }
                                                            >
                                                                 <h5>
                                                                      Are you
                                                                      sure, you
                                                                      want to
                                                                      delete ?
                                                                 </h5>
                                                            </UiConfirmationDialog>
                                                       </Tooltip>
                                                  </div>
                                             </TableCell>
                                        </TableRow>

                                        <TableRow>
                                             <TableCell
                                                  style={{
                                                       paddingBottom: 0,
                                                       paddingTop: 0,
                                                       border: "none",
                                                       background: "#f9f8f8",
                                                       borderBottom: "none",
                                                  }}
                                                  colSpan={12}
                                             >
                                                  <Collapse
                                                       in={
                                                            active == index &&
                                                            open
                                                       }
                                                       timeout="auto"
                                                       unmountOnExit
                                                  >
                                                       {active == index &&
                                                            open && (
                                                                 <UsersTableManage/>
                                                            )}
                                                  </Collapse>
                                             </TableCell>
                                        </TableRow>
                                   </>
                              ))}
                         </UiTableBody>
                    </UiTableWrapper>
               </div>
               <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />               
          </>
     );
}
